import { Observable } from "@apollo/client";

// Apollo observable which always returns the same error.
export const errorObservable = <T>(message: string) =>
  new Observable<T>((observer) => observer.error(new Error(message)));
